<template>
<div>
    <AppLoader v-if="isLoading" class="text-center" small />
    <b-container fluid>
        <b-navbar toggleable="lg" type="dark" variant="light">
            <b-navbar-brand href="#" class="text-dark">
                <strong>PRI Control Population</strong>
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">
                    <b-nav-form>
                        <b-button variant="outline-primary" size="sm" to="/pri-simulation" class="mx-2">
                            <font-awesome-icon icon="plus" />
                        </b-button>

                        <b-button variant="outline-info" size="sm" @click="onRefreshData">
                            <font-awesome-icon icon="sync" />
                        </b-button>
                        <b-form-group label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput">
                            <b-input-group size="sm">
                                <b-form-input type="search" id="filterInput" placeholder="Type to Search"></b-form-input>
                                <b-input-group-append>
                                    <b-button>Clear</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-nav-form>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>

        <b-table ref="table" id="my-table" table-class="tableClass" sticky-header="calc(100vh - 200px)" responsive="sm" :fields="tableFields" :busy="isLoading" :items="[]">

        </b-table>
        
    </b-container>
</div>
</template>

<script>
// import {HTTP} from "../utils/HTTP";
// import moment from "moment";
import AppLoader from "../components/Loader/Loader";

export default {
    name: "PriControlGroups",
    components: {
        AppLoader
    },
    data() {
        return {
            isLoading: false,
            tableFields:[
                {
                    key:'created_at',
                    label:'Created On'
                },
                {
                    key:'created_by',
                    label:'Created By'
                },
                {
                    key:'title',
                    label:'Control Group'
                },
                {
                    key:'no_of_third_parties',
                    label:'No of Subjects'
                },
                
                {
                    key:'action',
                    label:'Actions'
                }
            ]

        };
    },
    computed: {

    },
    mounted() {
        
    },
    methods: {
        onRefreshData() {
            this.$root.$emit("bv::refresh::table", "my-table");
            
        },
    }
};
</script>

<style scoped>
.pointer {
    cursor: pointer;
}

.table-col {
    /* max-height: calc(100vh - 140px); */
    /* overflow-y: scroll; */
}

.pagination {
    margin-top: 0;
}

.btn.btn-border {
    border: 1px solid;
    margin-right: 2px;
}

.vuetable-pagination-info {
    margin-top: 8px !important;
}

span.sort-icon {
    float: right;
    color: #ff9100;
}

.table-responsive-sm {
    /* height: calc(100vh - 140px) !important; */
    /* overflow-y: scroll !important */
}
</style>
